<ul class="view-labels">
  <li 
    class="view-labels__item" 
    [ngClass]="{'view-labels__item--selected': (selectedLabel$ | async)?.id === label.id}"
    (click)="handleLabelClick(label)"
    *ngFor="let label of (labels$ | async)">
    <div class="view-labels__pre">
      <div class="view-labels__pin">
        <div *ngIf="label.pinType === 'plusMinus'" style="height: 18px">+</div>
      </div>
    </div>

    <div class="view-labels__body">
      <div class="view-labels__title" [innerHTML]="label.title"></div>
      
      <div class="view-labels__description" [innerHTML]="label.description" *ngIf="label.description"></div>
    </div>
  </li>
</ul>